// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VDistpicker from 'v-distpicker'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'ace-builds/src-noconflict/ace.js';
// import 'codemirror/mode/python/python.js';
// import 'codemirror/theme/monokai.css';

// import VueCodemirror from 'vue-codemirror'
// import 'codemirror/lib/codemirror.css'

Vue.config.productionTip = false

// Vue.use(VueCodemirror)

Vue.use(ElementUI)
Vue.use(router)
Vue.prototype.$domain = 'http://static.smallschoolbag.com/'
Vue.mixin({
  computed:{
    $domain(){
      return 'http://static.smallschoolbag.com/'
    }
  }
})

router.beforeEach((to, from, next) => {
  console.log(to)
	if (to.meta.content) {
    console.log()
    if (!document.querySelector('meta[name="keywords"]')){
      let head = document.getElementsByTagName('head');
      let meta = document.createElement('meta');
      meta.name = 'keywords'
      meta.content = to.meta.content.keywords;
      let meta1 = document.createElement('meta');
      meta1.name = 'description'
      meta1.content = to.meta.content.description;
      let meta2 = document.createElement('meta');
      meta1.name = 'viewport'
      meta1.content = to.meta.content.viewport;
      head[0].appendChild(meta)
      head[0].appendChild(meta1)
    }
	}
	// if (to.meta.title) {
	// 	document.title = to.meta.title;
	// }
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
	next()
});

export default{
  component:{ VDistpicker }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js